<template>
	<div>
		<vxe-modal size="mini" v-model="model" width="1200" height="800" :show-footer="true" destroy-on-close
			@show="show" @hide="hide" transfer :lock-scroll="false" :showHeader="true" title="地址解密">
			<template #default>
				<el-tag type="danger" effect="plain">1.万里牛导出数据导入解密 </el-tag>
				<el-tag type="danger" effect="plain" style="margin-left: 10px;">2.可以随时导出，数据不会保存不要关闭窗口 </el-tag>
				<el-tag type="danger" effect="plain" style="margin-left: 10px;">3.解密失败先把数据导出来，通知管理员更换参数，然后再导进去继续解密</el-tag>
				<input ref="decodeaddressuploadfile" style="display: none;" type="file" @change="importMethod">
				<vxe-toolbar>
					<template #buttons>
						<vxe-button status="primary" @click="importdata">导入</vxe-button>
						<vxe-button @click="exportdata">导出</vxe-button>
						<vxe-button status="danger" @click="decode" :loading="loading">解密</vxe-button>
					</template>
				</vxe-toolbar>
				<el-divider content-position="center">订单数据</el-divider>
				<el-progress :percentage="progress" style="margin-bottom: 10px;"></el-progress>
				<vxe-grid v-bind="gridOptions" v-if="gridOptions" ref="decodeaddresstable">
				</vxe-grid>
				<exportTable :ref="exportRef" listType="report" />
			</template>

		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import exportTable from '@_system/components/export/index.vue'
	export default {
		props: {

		},
		data() {
			return {
				loading: false,
				model: true,
				form: {
					ordercode: null
				},
				tableList: [],
				orderinfo: [],
				columns: [],
				gridOptions: null,
				tabledata: [],
				exportRef: 'export_' + Math.random(),
				ordercode: '系统单号',
				buff: true,
				isfinish: true,
				totalNum:0,
				progress:0
			}
		},
		created() {

		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},

		methods: {
			getOption() {
				return {
					border: true,
					size: 'mini',
					data: this.tabledata,
					columns: this.columns,
					columnConfig: {
						isHover: false,
						resizable: true
					},
					customConfig: {
						storage: true
					},
					rowConfig: {
						isHover: true,
						isCurrent: true,
					},
					showOverflow: true,
					height: '80%',
					sortConfig: {
						remote: false
					}
				}
			},
			exportdata() {
				let columns = JSON.parse(JSON.stringify(this.columns))
				columns.forEach((item) => {
					item.visible = true
				})
				let obj = {
					data: this.tabledata,
					columns: columns
				}
				this.$refs[this.exportRef].exportData(obj)
			},
			importdata() {
				this.$refs.decodeaddressuploadfile.click()
			},
			importMethod(e) {
				let file = e.target.files[0]
				let reader = new FileReader();
				reader.onload = (e) => {
					let data = e.target.result
					let workbook = this.$XLSX.read(data, {
						type: 'binary'
					})
					let sheetName = workbook.SheetNames[0];
					let worksheet = workbook.Sheets[sheetName]
					let jsonData = this.$XLSX.utils.sheet_to_json(worksheet, {
						defval: null
					})
					if (jsonData.length != 0) {
						let columns = []
						for (let i in jsonData[0]) {
							let obj = {
								field: i,
								title: i,
								visible: false
							}

							if (i == this.ordercode || i == '详细地址' || i == '手机/电话' || i == '收货人') {
								obj.visible = true
							}
							columns.push(obj)
						}
						this.columns = columns
						this.tabledata = jsonData
						this.gridOptions = this.getOption()
						this.importLoading = false
					} else {
						this.importLoading = false
						this.$message.error('暂无数据')
					}
				}
				reader.readAsBinaryString(file)


			},
			decode() {
				if (this.isfinish) {
					this.loading = true
					this.isfinish = false
					let data = []
					this.tabledata.forEach((item) => {
						let index = data.findIndex((_item) => {
							return _item[this.ordercode] == item[this.ordercode]
						})
						if (!item['详细地址'] && index == -1) {
							data.push(item)
						}
					})
					const tasks = [];
					this.totalNum = data.length
					for (let i = 0; i < data.length; i++) {
						tasks.push(this.createTask(data[i],i))
					}

					// 执行任务
					this.processTasksSequentially(tasks).then(() => {
						this.isfinish = true
						this.loading = false
						console.log('All tasks completed');
					});
				} else {
					this.$message.error('解密进行中')
				}
			},
			fomattercontroll(controll) {
				if (controll == 0) {
					return '无'
				}
				if (controll == 1) {
					return '无'
				}
				if (controll == 2) {
					return '拆出改仓'
				}
			},
			show() {
				this.progress = 0
				this.buff = true
			},
			hide() {
				this.progress = 0
				this.buff = false
				this.$emit('hide')
			},
			submit() {
				console.log(this.tableList)
				this.$api.tool.saveSplitTrade({
					data: this.tableList
				}).then(() => {
					this.$message.success('操作成功')
				})
			},
			getaddress(item,index) {
				
				let time = parseInt(Math.random() * 5000 + 5000)
				return new Promise((resolve) => {
					setTimeout(() => {
						this.$api.tool.decodeaddress({
							salercpt_no: item[this.ordercode]
						}).then((res) => {
							console.log(res)
							this.tabledata.forEach((_item) => {
								if (_item[this.ordercode] == item[this.ordercode]) {
									_item['详细地址'] = res.address
									_item['手机/电话'] = res.mobile?res.mobile:res.phone
									_item['收货人'] = res.receiver_name
								}
							})
							this.progress = parseInt((index+1)/this.totalNum*100)
							resolve()
						})
					}, time)
				})
			},

			// 模拟异步任务的函数
			createTask(item,index) {
				return () => this.getaddress(item,index).then(() => console.log(item[this.ordercode] + ' finish'));
			},

			// 按顺序执行任务的函数
			async processTasksSequentially(tasks) {
				for (const task of tasks) {
					await task();
					if (!this.buff) {
						break
					}
				}
			}

		},
		components: {
			exportTable
		}
	}
</script>